import alert from '@/plugins/alert'
import { StudentCreditApi } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    studentCredits: [],
    studentCredit: {},
    itemsPerPage: 10,
    count: 0,
    filter: {},
    loading: false,
    studentCreditReports: [],
  },
  actions: {
    async fetch({ commit }, params) {
      try {
        const res = await StudentCreditApi.fetchByStudent({ params })
        commit('setStudentCredits', res)
      } catch (error) {
        alert.error('Tải dữ liệu học sinh thất bại')
      }
    },
    async fetchOne({ commit }, id) {
      try {
        const res = await StudentCreditApi.fetchOne(id)
        commit('setStudentCredit', res)
        return res
      } catch (error) {
        alert.error('Tải dữ liệu học sinh thất bại')
      }
    },
    async fetchCount({ commit }, params) {
      try {
        const res = await StudentCreditApi.countByStudent({ params })
        commit('setCount', res)
      } catch (error) {
        alert.error('Có lỗi xảy ra. Vui lòng thử lại')
      }
    },
    async requestCharge(_, data) {
      await StudentCreditApi.requestCharge({ ...data })
    },
    onChangeAmount({ commit }, { id, amount }) {
      commit('onChangeAmount', { id, amount })
    },
    setItemsPerPage({ commit }, data) {
      commit('setItemsPerPage', data)
    },
    setFilter({ commit }, data) {
      commit('setFilter', data)
    },
    setLoading({ commit }, payload) {
      commit('setLoading', payload)
    },
    async fetchStudentCreditReports({ commit }, params) {
      const res = await StudentCreditApi.studentCreditReport({ params })
      commit('setStudentCreditReports', res)
      return res
    },
    async fetchStudentCreditIndependent(_, params) {
      const res = await StudentCreditApi.fetch(params)
      return res
    },
    resetStudentCredit({ commit }) {
      commit('resetStudentCredit')
    },
  },
  mutations: {
    setStudentCredits(state, payload) {
      state.studentCredits = payload
    },
    setStudentCredit(state, payload) {
      state.studentCredit = payload
    },
    setItemsPerPage(state, data) {
      state.itemsPerPage = data
    },
    setCount(state, data) {
      state.count = data
    },
    setFilter(state, data) {
      state.filter = data
    },
    onChangeAmount(state, payload) {
      const { id, amount } = payload
      const index = state.studentCredits.findIndex((v) => v.id === id)
      if (index !== -1) {
        state.studentCredits[index].value += amount
      }
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setStudentCreditReports(state, payload) {
      state.studentCreditReports = payload
    },
    resetStudentCredit(state) {
      state.studentCredit = {}
    },
  },
  getters: {
    studentCredits: (state) => state.studentCredits,
    studentCredit: (state) => state.studentCredit,
  },
}
